import React, { useRef } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "../styles/Contact.css";

// ✅ react-icons import
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

// ✅ EmailJS import
import emailjs from "emailjs-com";

export default function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_yg355h2",      // replace with your EmailJS service ID
        "template_ypp1zo8",     // replace with your EmailJS template ID
        form.current,
        "MFJP4P45HoIcTPc9Q"       // replace with your EmailJS public key
      )
      .then(
        (result) => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("Failed to send message. Please try again.");
          console.log(error.text);
        }
      );
  };

  return (
    <>
      <Navbar />

      <section className="contact-section">
        <h2 className="contact-heading">GET IN TOUCH WITH US</h2>
        <p className="contact-sub">
          Our team is available 24x7 for direct assistance. Please feel free to contact us.
        </p>

        <div className="contact-grid">
          {/* Left side – details */}
          <div className="contact-details">

            <div className="detail-box">
              <div className="icon">
                <FaMapMarkerAlt />
              </div>
              <div>
                <h3>Registered Address</h3>
                <p>
                  CITY SURVEY NO.12229, QAYYUM APARTMENT,<br/>
                  NANDED, MAHARASHTRA, INDIA, 431602
                </p>
              </div>
            </div>

            <div className="detail-box">
              <div className="icon">
                <FaEnvelope />
              </div>
              <div>
                <h3>Email Address</h3>
                <p>aadil@zrknex.com</p>
              </div>
            </div>

            <div className="detail-box">
              <div className="icon">
                <FaPhoneAlt />
              </div>
              <div>
                <h3>Mobile Number</h3>
                <p>+919309318892</p>
                
              </div>
            </div>

          </div>

          {/* Right side – form */}
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <input type="text" name="name" placeholder="Name*" required />
              {/* <input type="tel" name="mobile" placeholder="Mobile Number" /> */}
              <input type="email" name="email" placeholder="Email*" required />
              <input type="text" name="subject" placeholder="Your Subject*" required />
              <textarea name="message" placeholder="Message" rows="5"></textarea>
              <button type="submit">Submit Now</button>
            </form>
          </div>
        </div>

        {/* Google Map Embed */}
        <div className="map-container">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3500.000000!2d77.000000!3d28.000000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z!5e0!3m2!1sen!2sin!4v000000000"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>

      <Footer />
    </>
  );
}
